import React from 'react';

const rateRows = [
  { label: 'Hourly', col2: '$95/hr', col3: '$120/hr', italic: false },
  { label: 'Day rate', col2: '$560/day', col3: '$710/day', italic: false },
  { label: 'Weekly block (4 days)', col2: '$2,080', col3: '$2,640', italic: false },
  { label: 'Monthly retainer', col2: 'From $4,200', col3: 'From $5,400', italic: false },
  { label: 'Fixed project', col2: 'Quoted per scope', col3: 'Quoted per scope', italic: true },
];

const models = [
  {
    title: 'Fixed-scope project',
    body: 'A defined deliverable like a dashboard, a pipeline, or a model. Best when you know what you need.',
  },
  {
    title: 'Day rate or embedded',
    body: 'Hands-on delivery inside your team for discovery, advisory, or build work.',
  },
  {
    title: 'Retainer',
    body: 'Ongoing analytics, monitoring, or model upkeep, billed monthly.',
  },
];

const cellLeft = {
  padding: '18px 26px',
  fontSize: '14.5px',
  color: 'rgba(232,238,240,0.8)',
};
const cellRight = {
  padding: '18px 26px',
  borderLeft: '1px solid rgba(255,255,255,0.08)',
  fontSize: '15px',
  color: '#fff',
};
const cellRightItalic = {
  ...cellRight,
  fontSize: '14px',
  color: 'rgba(232,238,240,0.6)',
  fontStyle: 'italic',
};

const Pricing = () => (
  <section
    id="rates"
    className="zk-section-pad zk-section-gutter"
    style={{ maxWidth: '1180px', margin: '0 auto', padding: '120px 56px' }}
  >
    <div style={{ marginBottom: '32px' }}>
      <span style={{ fontFamily: 'var(--zk-mono)', fontSize: '12px', letterSpacing: '0.28em', color: '#ff3ea5' }}>
        {'// ENGAGEMENT_PRICING'}
      </span>
      <h2
        style={{
          margin: '18px 0 0',
          fontSize: 'clamp(34px, 4vw, 52px)',
          fontWeight: 600,
          letterSpacing: '-0.02em',
          lineHeight: 1.04,
        }}
      >
        Honest, upfront pricing.
      </h2>
    </div>
    <p
      style={{
        maxWidth: '760px',
        margin: '0 0 48px',
        fontSize: '17px',
        lineHeight: 1.6,
        color: 'rgba(232,238,240,0.74)',
        textWrap: 'pretty',
      }}
    >
      No mystery quotes, no enterprise mark-up. Most work runs as a fixed-scope project with defined deliverables; for ongoing or embedded work, a day rate or monthly retainer fits better. Whichever model, you get a clear scope and a defined result before we start, and you always know what it costs.
    </p>

    <div style={{ border: '1px solid rgba(255,255,255,0.1)', borderRadius: '4px', overflow: 'hidden' }}>
      <div className="zk-rate-row" style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr' }}>
        <div
          className="zk-rate-cell"
          style={{
            padding: '20px 26px',
            background: 'rgba(255,255,255,0.025)',
            fontFamily: 'var(--zk-mono)',
            fontSize: '11px',
            letterSpacing: '0.14em',
            color: 'rgba(232,238,240,0.5)',
            textTransform: 'uppercase',
          }}
        >
          Engagement
        </div>
        <div
          className="zk-rate-cell"
          style={{
            padding: '20px 26px',
            background: 'rgba(255,255,255,0.025)',
            borderLeft: '1px solid rgba(255,255,255,0.08)',
            fontSize: '14px',
            fontWeight: 600,
            color: '#38e0ff',
          }}
        >
          Clarity &amp; Data
        </div>
        <div
          className="zk-rate-cell"
          style={{
            padding: '20px 26px',
            background: 'rgba(255,255,255,0.025)',
            borderLeft: '1px solid rgba(255,255,255,0.08)',
            fontSize: '14px',
            fontWeight: 600,
            color: '#ff3ea5',
          }}
        >
          Applied AI / ML
        </div>
      </div>
      {rateRows.map((row, i) => (
        <div
          key={row.label}
          className="zk-rate-row"
          style={{
            display: 'grid',
            gridTemplateColumns: '1.4fr 1fr 1fr',
            borderTop: '1px solid rgba(255,255,255,0.08)',
            background: i % 2 === 1 ? 'rgba(255,255,255,0.012)' : undefined,
          }}
        >
          <div className="zk-rate-cell" style={cellLeft}>{row.label}</div>
          <div className="zk-rate-cell" style={row.italic ? cellRightItalic : cellRight}>{row.col2}</div>
          <div className="zk-rate-cell" style={row.italic ? cellRightItalic : cellRight}>{row.col3}</div>
        </div>
      ))}
    </div>
    <p style={{ margin: '18px 0 56px', fontSize: '13px', lineHeight: 1.6, color: 'rgba(232,238,240,0.55)' }}>
      All prices AUD, exclude GST. A day rate works out cheaper than booking the same time hourly, so committing to a block saves you money.
    </p>

    <div
      className="zk-grid-engagement"
      style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}
    >
      {models.map((m) => (
        <div
          key={m.title}
          style={{
            padding: '26px',
            background: 'rgba(255,255,255,0.018)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '3px',
          }}
        >
          <h4 style={{ margin: '0 0 10px', fontSize: '16px', fontWeight: 600, color: '#ff3ea5' }}>{m.title}</h4>
          <p style={{ margin: 0, fontSize: '13.5px', lineHeight: 1.55, color: 'rgba(232,238,240,0.66)' }}>{m.body}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Pricing;
